export const OPTION = Object.freeze({
  gummy: 'gummy',
  capsule: 'capsule',
  otc: 'otc',
});

export const OPTION_DATA = Object.freeze({
  [OPTION.gummy]: {
    label: 'Gummies',
  },
  [OPTION.capsule]: {
    label: 'Capsule',
  },
});

// product purchase type
export const TYPE = Object.freeze({
  subscription: 'subscription',
  oneTime: 'one-time',
});

export const TYPE_DATA = Object.freeze({
  [TYPE.subscription]: {
    label: 'Subscribe & Save',
    subLabel: 'Easy to cancel, anytime',
    subLabelBold: 'Free Shipping Always',
  },
  [TYPE.oneTime]: {
    label: 'One Time',
    subLabel: 'One Time Purchase',
    subLabelBold: '',
  },
});

// quantity selection
export const QUANTITY_SELECTION = Object.freeze([1, 2, 3]);


/**
 * Find product from the array based on the current selection
 * @param {[Object]} products - Array of products
 * @param {PRODUCT.OPTION} option - Selected option (gummy vs capsule)
 * @param {PRODUCT.TYPE} type - Selected type (subscription vs one time)
 * @param {number} quantity - Selected quantity
 * @returns {Object} product
 */
export const findProduct = (products, option, type, quantity) => {
  return products.find((val) => {
    return (
      val.metafields.includes.includes(`-${option}=${quantity}`) &&
      val.metafields.type === type
    );
  });
};

/**
 * Find varint from the selected product and quantity
 * @param {Object} product - Selected product
 * @param {number} quantity - Selected quantity
 * @returns {Object} variant
 */
export const findVariant = (product, quantity) => {
  return product.variants[quantity !== 3 ? 0 : product.variants.length - 1];
};

export const addToCart = async (product, variant, type) => {
  const data = {
    items: [
      {
        id: variant.id,
        quantity: 1,
      },
    ],
  };

  if (type === TYPE.subscription) {
    data.items[0].selling_plan =
      product.selling_plan_groups[0].selling_plans[0].id;
  }

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  } catch (err) {
    console.error("Error:", err);
  }
};

export const getQuantityMessage = (quantity) => {
  if (quantity === 1) {
    return "1 bottle ships every 1 month";
  } else {
    return `${quantity} bottles ship every ${quantity} months`;
  }
};
